/*
 * bk-filter-bar.js
 * Proxy-Logik fuer die horizontale Filter-Leiste (snippets/bk-filter-bar.liquid).
 * Keine eigene Filter-Logik: jede Interaktion wird an die echten Inputs im
 * Sidebar-Formular (#facets) weitergeleitet, damit Canopys facet-filters.js
 * (FormData, Section-Rendering-API, History) unveraendert laeuft.
 *
 * Alles laeuft ueber delegierte Listener auf document, weil facet-filters.js
 * nach jeder Auswahl das innerHTML von #filter-results (inkl. Leiste) ersetzt —
 * so ist kein Re-Init noetig. Ein MutationObserver oeffnet danach das zuletzt
 * benutzte Dropdown wieder.
 */
(function () {
  var openKey = null;

  function findRealCheckbox(name, value) {
    var form = document.getElementById('facets');
    if (!form) return null;
    var inputs = form.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < inputs.length; i += 1) {
      if (inputs[i].name === name && inputs[i].value === value) return inputs[i];
    }
    return null;
  }

  function rememberOpen(el) {
    var item = el.closest('[data-bk-fbar-item]');
    openKey = item ? item.getAttribute('data-bk-fbar-item') : null;
  }

  function closeAll(except) {
    document.querySelectorAll('.bk-fbar details[open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  // --- Proxy: Checkbox- und Preis-Aenderungen an die Sidebar weiterleiten ---
  document.addEventListener('change', function (evt) {
    var t = evt.target;

    if (t.matches('[data-bk-fbar-proxy]')) {
      var real = findRealCheckbox(t.getAttribute('data-name'), t.getAttribute('data-value'));
      if (!real) return;
      rememberOpen(t);
      // .click() toggelt + feuert input/change INNERHALB von .facets__filters
      if (real.checked !== t.checked) real.click();
    } else if (t.matches('[data-bk-fbar-price]')) {
      var realPrice = document.getElementById('price-range-number-' + t.getAttribute('data-bk-fbar-price'));
      if (!realPrice) return;
      rememberOpen(t);
      realPrice.value = t.value;
      // 'change' + id enthaelt 'price-range' -> wird von facet-filters.js akzeptiert
      realPrice.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // --- "Zuruecksetzen" proxyt auf den .js-clear-filter-Link der Sidebar;
  //     Klick ausserhalb schliesst offene Dropdowns ---
  document.addEventListener('click', function (evt) {
    var clear = evt.target.closest('[data-bk-fbar-clear]');
    if (clear) {
      var details = document.getElementById(clear.getAttribute('data-target'));
      var link = details && details.querySelector('.js-clear-filter');
      if (link) {
        rememberOpen(clear);
        link.click();
      }
      return;
    }

    var inBar = evt.target.closest('.bk-fbar details');
    closeAll(inBar);
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') closeAll(null);
  });

  // Nur ein Dropdown gleichzeitig offen ('toggle' bubblet nicht -> capture)
  document.addEventListener('toggle', function (evt) {
    var d = evt.target;
    if (d.matches && d.matches('.bk-fbar details[open]')) closeAll(d);
  }, true);

  // --- Nach dem Re-Render von #filter-results das aktive Dropdown wieder oeffnen ---
  function initObserver() {
    var results = document.getElementById('filter-results');
    if (!results || results.__bkFbarObserved) return;
    results.__bkFbarObserved = true;

    new MutationObserver(function () {
      if (!openKey) return;
      var key = openKey;
      openKey = null; // nur einmal wieder oeffnen, nicht bei spaeteren Re-Renders
      var item = results.querySelector('[data-bk-fbar-item="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      if (item) item.setAttribute('open', '');
    }).observe(results, { childList: true });
  }

  if (document.readyState !== 'loading') initObserver();
  else document.addEventListener('DOMContentLoaded', initObserver);
  document.addEventListener('shopify:section:load', initObserver);
})();
